// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { StringUtils } from '@shared/utils/StringUtils';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { AccountOperations } from '../../AccountOperations';
import { DataCache } from '../../DataCache';
export class StatementFormatter {
    static Account(statement) {
        return DataCache.GetAccountById(statement.AccountId.toString());
    }
    static AccountStr(statement) {
        const account = StatementFormatter.Account(statement);
        return account === null || account === void 0 ? void 0 : account.toString();
    }
    static DateStr(statement) {
        return this.DateToString(statement.Date);
    }
    static TradeOpeningDateStr(statement) {
        return this.DateToString(statement.TradeOpeningDate);
    }
    static AmountStr(statement, noCurrency = true) {
        const amount = statement.Amount;
        const asset = DataCache.GetAssetByName(statement.Currency);
        if (!isNullOrUndefined(asset)) {
            return asset.formatPrice(amount, noCurrency);
        }
        return isValidNumber(amount) ? amount.toString() : '';
    }
    static OperationTypeStr(statement) {
        const operationtypeId = statement.OperationTypeId;
        if (!isValidNumber(operationtypeId)) {
            return statement.OperationType;
        }
        const localizationKey = AccountOperations.getTypeLocalizationKey(operationtypeId);
        return localizationKey === undefined ? statement.OperationType : Resources.getResource(localizationKey);
    }
    static DateToString(date) {
        return isNaN(date.getTime())
            ? StringUtils.NOT_AVAILABLE
            : DateTimeUtils.formatDate(date, 'DD.MM.YYYY  HH:mm:ss');
    }
}
